import { CerExcelColumn } from "./cer-data-import-excel-reader";
import { CerDataImportMapSourceColumn } from "./cer-data-import-mapper";

export class CerDataImportExcelPreMapper {

  public static mapExcelColumns(excelColumns: CerExcelColumn[]): CerDataImportMapSourceColumn[] {
    const columns: CerDataImportMapSourceColumn[] = [];
    excelColumns.forEach(c => {
      columns.push(
        {
          text: c.title,
          name: c.name ?? c.title,
          origin: 'importData',
          index: c.index,
          linkType: 'none'
        } as CerDataImportMapSourceColumn
      )
    });
    return columns;
  }
}
